<template>
  <v-app>
    <Sidebar v-if="$router.currentRoute.name !== 'Login'"></Sidebar>
    <router-view />
  </v-app>
</template>

<script>
import Sidebar from './components/Sidebar.vue'
// import router from './router'

export default {
  name: 'App',
  components: {
    Sidebar
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Kanit&display=swap');
*,
.v-application {
  font-family: Kanit;
  /* font-size: 22px !important; */
}
html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
  overflow-x: hidden !important;
}
.v-list-item {
  background-color: #1b437c !important;
}
:root {
  --nav-bg: #1b437c;
  --nav-text: #ffffff;
  --nav-text-active: #173053;
  --panel-bg: #173053;
  --panel-text: #ffffff;
  --table-head-bg: #173053;
  --table-head-text: #ffffff;
  --table-body-row-even: #b1c9ea;
  --table-body-row-odd: #ffffff;
  --table-body-text: #1b437c;
  --btn-general-color: #ffffff;
  --date-picker-head: #b1c9ea;
  --date-picker-footer: #173053;
  --date-picker-table-head: #5c99db;
  --date-picker-table-body: #1b437c;
}
/* .KittithadaBold {
  font-family: KittithadaBold !important;
} */
.v-toolbar__content {
  padding: 4px 16px;
  justify-content: space-around !important;
}
.nav-bg {
  /* background-color: var(--nav-bg) !important; */
}
/* h1 {
  font-size: 2.5rem;
} */
/* h2 {
  font-size: 2rem !important;
} */
h3 {
  font-size: 1.5rem !important;
}
.h3-Bold {
  font-family: KittithadaBold;
  font-size: 1.65rem !important;
}
h4 {
  font-family: Kittithada;
  font-size: 1.15rem !important;
}
.btn-color {
  background-color: #272727 !important;
}
.backg-color {
  background-color: #f2f1f9;
}
.text-color {
  color: #130a29;
}
.v-btn:focus {
  outline: none;
}
.svg-container {
  display: inline-block !important;
  position: relative !important;
  width: 100% !important;
  height: auto !important;
  padding-bottom: 39% !important;
  vertical-align: top !important;
  overflow: hidden !important;
}
.svg-content {
  display: inline-block !important;
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
}
.chart-text-up {
  color: #09b66d !important;
}
.chart-text-down {
  color: #ff3d57 !important;
}
.svg-container > svg text {
  fill: #617087 !important;
  font-size: 15px !important;
  text-anchor: center !important;
}
.bar {
  fill: var(--nav-bg) !important;
}
.grid {
  fill: none;
  stroke: #444 !important;
  stroke-width: 1.5px !important;
}
.chartHead {
  font-size: 1.65rem !important;
  font-weight: 300 !important;
  letter-spacing: 0.0125em !important;
}
.nav-text-active {
  color: var(--nav-text-active) !important;
}
.nav-text {
  color: var(--nav-text) !important;
}
.c3-axis-y-label,
.c3-axis-x-label,
.c3-chart-arcs-gauge-min,
.c3-chart-arcs-gauge-max {
  font-size: 17px !important;
}
.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  /* color: var(--table-head-text) !important; */
  font-size: 15px;
}
.v-card__subtitle,
.v-card__text,
.v-card__title {
  padding: 16px !important;
}
table tr:first-child th:first-child {
  border-top-left-radius: 10px;
}
table tr:first-child th:last-child {
  border-top-right-radius: 10px;
}
table tr:last-child td:first-child {
  border-bottom-left-radius: 10px;
}
table tr:last-child td:last-child {
  border-bottom-right-radius: 10px;
}
.v-application a {
  color: var(--nav-bg) !important;
}
.theme--light.v-btn.v-btn--has-bg {
  background-color: var(--nav-bg);
}
.v-icon.v-icon.v-icon--link {
  color: var(--nav-bg) !important;
}
.v-navigation-drawer__content {
  background-color: var(--nav-bg) !important;
}
.v-application--is-ltr
  .v-list-group--no-action
  > .v-list-group__items
  > .v-list-item {
  padding-left: 45px !important;
}
.v-application--is-ltr .v-list-item__action:first-child,
.v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: 15px !important;
}
.theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled)
  .v-list-item__title,
.v-btn__content {
  color: var(--nav-text) !important;
  font-family: KittithadaBold !important;
  font-size: 22px !important;
}
.buttonColor {
  color: var(--nav-text) !important;
  font-family: KittithadaBold !important;
  font-size: px !important;
}
.v-list-item__title {
  color: var(--nav-text) !important;
  font-family: KittithadaBold !important;
  font-size: 22px !important;
}
.v-select-list {
  background-color: var(--nav-bg) !important;
}
.v-input--selection-controls__input > .v-icon {
  color: var(--nav-bg) !important;
}
.v-simple-checkbox .v-icon {
  color: white !important;
}
.v-picker {
  background-color: var(--date-picker-footer) !important;
}
.v-date-picker-header {
  background-color: var(--date-picker-head) !important;
}
.v-date-picker-table {
  background-color: var(--date-picker-head) !important;
}
.v-date-picker-table > table > thead {
  background-color: var(--date-picker-table-head) !important;
}
.v-date-picker-table > table > tbody {
  background-color: var(--date-picker-table-body) !important;
}
.v-date-picker-table--date th {
  padding: 0px 0;
}
.v-list-group__header {
  background-color: var(--nav-bg) !important;
}
.theme--light.v-icon {
  color: var(--nav-text);
}
.menu-head {
  color: var(--nav-text) !important;
  font-family: KittithadaBold !important;
  font-size: 26px !important;
}
.v-list-item--active {
  background-color: var(--nav-text-active) !important;
}
.v-toolbar {
  background-color: var(--nav-bg) !important;
  color: var(--nav-text) !important;
}
.theme--light.v-app-bar.v-toolbar.v-sheet {
  background-color: var(--nav-bg) !important;
  color: var(--nav-text) !important;
}
.v-expansion-panel-header {
  background-color: var(--panel-bg) !important;
  color: var(--panel-text) !important;
  font-weight: bold !important;
}
.v-expansion-panel--active > .v-expansion-panel-header {
  min-height: 48px !important;
}
.v-breadcrumbs {
  font-weight: bold !important;
}
.v-data-table-header {
  background-color: var(--table-head-bg) !important;
}
.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  color: var(--table-head-text) !important;
}
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  padding: 8px 5px 8px 15px !important;
  color: #000000 !important;
}
.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:nth-child(even)
  > td {
  background: var(--table-body-row-even);
}
.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:nth-child(odd)
  > td {
  background: var(--table-body-row-odd);
}
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  color: var(--table-body-text) !important;
}
.theme--light.v-data-table .v-data-table-header th.sortable.active,
.theme--light.v-data-table
  .v-data-table-header
  th.sortable.active
  .v-data-table-header__icon,
.theme--light.v-data-table .v-data-table-header th.sortable:hover {
  color: var(--table-head-text) !important;
}
.theme--light.v-data-table
  .v-data-table-header
  th.sortable
  .v-data-table-header__icon {
  color: var(--table-head-text) !important;
}
.btn {
  color: var(--btn-general-color) !important;
}
.nav-button {
  color: var(--nav-text) !important;
  background-color: var(--nav-bg) !important;
}
.shopname {
  font-size: 26px !important;
  font-weight: bold !important;
}
.theme--light.v-card {
  border-radius: 11px !important;
}
.v-card__subtitle,
.v-card__text,
.v-card__title {
  padding: 0px;
}
.v-text-field {
  padding: 16px !important;
}
.v-card_color {
  background-color: var(--nav-text-active) !important;
  width: 350px !important;
  height: 600px !important;
}
.v-margit_button {
  margin-top: 15px !important;
}
.v-margit_img {
  margin-top: 150px !important;
}
.v-margit_img_reward {
  margin-top: 90px !important;
}
.v-margit_text_add {
  margin-top: 10px !important;
}
.v_text_add {
  color: var(--nav-text-active) !important;
  width: 170px !important;
  height: 50px !important;
}
.v_text_edit {
  width: 255px !important;
  height: 52px !important;
}
.v-img-margit {
  width: 128.19px !important;
  height: 84px !important;
}
/* css champ */
</style>



// WEBPACK FOOTER //
// src/App.vue